/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Media_ClearInputs */

const cs_draft_media_clear = /** @type {(inputs: Draft_Media_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vymazat`)
};

const en_draft_media_clear = /** @type {(inputs: Draft_Media_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear`)
};

/**
* | output |
* | --- |
* | "Clear" |
*
* @param {Draft_Media_ClearInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_media_clear = /** @type {((inputs?: Draft_Media_ClearInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Media_ClearInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_media_clear(inputs)
	return cs_draft_media_clear(inputs)
});